import axios from 'axios'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function recuperarConfiguracaoStoneConnect(empresaId) {
  const url = `${URL}/empresas/${empresaId}/configurar-stone-connect`;
  return () => axios.get(url, SLOW_REQUEST_CONFIG);
}
